import about1 from "./Images/Illustration/abut.jpg";
import about2 from "./Images/Illustration/bgcar.png";
import toyota from "./Images/Illustration/toyota-offer-2.861de085d1c782df9e9d.png";
import driver1 from "./Images/Illustration/driver-1.cc28e20ef89a3dd83430.jpg";
import driver2 from "./Images/Illustration/driver2.jpg";
import driver3 from "./Images/Illustration/driver-3.154de7902469bef24a47.jpg";
import driver4 from "./Images/Illustration/driver-4.c8e5ec8a940eb337ad54.jpg";


const About = () => {
  return (
    <section class='container-fluid'>
      <div class='row'>
        <div class='col-12 back2 text-white align'>
          <h3>About</h3>

          <div className="d-flex justify-content-center pt-3"> <nav aria-label="breadcrumb ">
            <ol class="breadcrumb ">
              <li class="breadcrumb-item"><a href="Home">Home</a></li>
              <li class="breadcrumb-item active" aria-current="About">About</li>
            </ol>
          </nav></div>

        </div>
        <div class='col-12 py-5'>
          <div className="row">
            <div className="col-12 col-md-6">
              <h4 className="orange">About Us</h4>
              <h3>We are committed to provide safe Ride solutions</h3>
              <p>Claritas est etiam processus dynamicus, qui sequitur mutationem consuetudi- um lectorum. Mirum est notare quam littera gothica, quam nunc putamus parum claram, anteposuerit litterarum formas humanitatis per seacula quarta decima et quinta decima.</p>
              <p>Eodem modo typi, qui nunc nobis videntur parum clari, fiant sollemnes in futurum.litterarum formas humanitatis per seacula quarta decima et quinta decima</p>
              <div className=" col-4 border border-2 shadow"><p className="orange">Need any help?</p>
                <h4>(431) 529 2093</h4></div>
            </div>
            <div className="col-12 col-md-6">
              <img src={about1} className="img-fluid" alt="image not found" />
            </div>
          </div>

          <div className="row py-5 proud">
            <div className="col-12 fw-bolder text-center py-5 ">
              <h3>We are proud of our business.<br /><span className="orange">Rent Car</span> Now !</h3>
              <img src={about2} className="img-fluid" alt="image not found" />
            </div>
          </div>

          <div className="row back1 text-white text-center justify-content-center">
            <div className="col-12 col-md-6 py-5 bg-dark bg-opacity-75"> <img src={toyota} alt='Image Not Found' /></div>
            <div className="col-12 col-md-6 py-5">
              <h3>Do You Want To Earn With Us? So Don't be Late.</h3>
              <a className="btn text-white" href="#">Become a Driver</a>
            </div>
            
          </div>
          <div className="row driver text-center py-5 d-flex justify-content-center">
            <h4 className="orange">Experts</h4>
            <h2 className="pb-5">Our Members</h2>
            <div className="col-12 col-md-6 col-lg-3"><img src={driver1} className="img-fluid" alt="image not found"/><h3>Marco Ghaly</h3><p className="text-muted">4 Years Experience</p></div>
            <div className="col-12 col-md-6 col-lg-3"><img src={driver2} className="img-fluid" alt="image not found"/><h3>Sheref Joe</h3><p className="text-muted">7 Years Experience</p></div>
            <div className="col-12 col-md-6 col-lg-3"><img src={driver3} className="img-fluid" alt="image not found"/><h3>Arafa Lep</h3><p className="text-muted">3 Years Experience</p></div>
            <div className="col-12 col-md-6 col-lg-3"><img src={driver4} className="img-fluid" alt="image not found"/><h3>Endly Kent</h3><p className="text-muted">4 Years Experience</p></div>
            <div className="pt-5"><a className="btn col-2" href="#">More Members</a></div>
          </div>
         

        </div>
      </div>
    </section>
  )

};

export default About;
